import { AvailabilitySlot } from '../../../../shared/AvailabilitySlots/AvailabilitySlot/types';
import { filterSlotByValueDate } from '../../../../helpers/filterSlotByValueDate';
import { scheduling } from '@morf/proto/scheduling/v1/scheduling_ts_proto';
import { values } from '@morf/proto/values/v1/values_ts_proto';

export const groupAvailabilitySlotsByWeekday = (
  monthlyAvailabilitySlots: scheduling.v1.ListAvailabilitySlotsResponse[],
  weekday: values.v1.Date
): AvailabilitySlot[] => {
  const slotRecord: Record<string, AvailabilitySlot> = {};

  monthlyAvailabilitySlots.forEach(({ providerId, slots }) => {
    slots.forEach((slot) => {
      if (filterSlotByValueDate(slot, weekday)) {
        const key = `${slot.seconds.low}-${slot.nanoseconds}`;

        if (!slotRecord[key]) {
          slotRecord[key] = { providerId, slot };
        }
      }
    });
  });

  return Object.values(slotRecord);
};
